import React, { useState } from 'react'
import TextareaField from '../../elements/form/TextareaField'
import ModalActionButton from '../../elements/ModalActionButton'
import { useDispatch } from 'react-redux'
import { ERROR } from '../../../store/types'
import axios from 'axios'
import { authHeader } from '../../../utils'

const DeclineExeat = ({exeat, close, reload}) => {
  const dispatch = useDispatch()
  const [remarks, setRemarks] = useState('')
  const [validationErrors, setValidationErrors] = useState({})
  const [processing, setProcessing] = useState(false)

  const declineExeat = async () => {
    if (remarks === '') {
      setValidationErrors({remarks: true})
      dispatch({
        type: ERROR,
        error: {response: {data: {
          message: 'Please check the highlighted fields'
        }}}
      });
      return
    }
    try {
      const headers = authHeader()

      const payload = {
        remarks
      }
      setProcessing(true)
      await axios.post(`${process.env.REACT_APP_BASE_URL}/exeats/decline/${exeat._id}`, payload, { headers })
      setProcessing(false)
      reload()
      close()
    } catch (error) {
      console.error('error declining exeat: ', error)
      dispatch({
        type: ERROR,
        error
      });
      setProcessing(false)
    }
  }

  return (
    <div className='w-full'>
      <p className='text-sm text-gray-600'>This exeat will be declined and the student will not be able to use it any more. Please provide your remarks/reason for declining it in the text box below.</p>

      <div className='my-2 w-full'>
        <TextareaField
          inputLabel="Exeat note/Reason" 
          fieldId="note" 
          inputType="text" 
          requiredField={false}
          inputPlaceholder="Add a note"
          preloadValue={remarks}
          hasError={validationErrors.remarks} 
          returnFieldValue={(value)=>{setRemarks(value)}}
        />
      </div>

      <div className="mt-8 flex flex-row-reverse gap-x-4">
        <ModalActionButton
          buttonLabel={`Decline Exeat`}
          buttonAction={()=>{declineExeat()}}
          processing={processing}
        />

        <button
          type="button"
          className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
          onClick={()=>{close()}}
        >
          Close
        </button>
          
      </div>
    </div>
  )
}

export default DeclineExeat